export enum HttpStatus {
    SUCCESS = 200,
    BAD_REQUEST_EXCEPTION = 400,
    NOT_FOUND_EXCEPTION = 404,
    UNAUTHORIZED_EXCEPTION = 401,
    SERVER_ERROR = 500,
}
